import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgBookmarkFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18c1.559.983 5.051 3.116 5.844 3.652 1.008.682 2.156.322 2.156-.73V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16.923c0 1.05 1.148 1.41 2.156.729C6.95 21.116 10.441 18.983 12 18Z", fill: color }));
};
export default factorySvgIcon(SvgBookmarkFilled);
//# sourceMappingURL=SvgBookmarkFilled.js.map